"use client";

import { usePathname } from "next/navigation";
import { createContext, useContext } from "react";

import Header from "./Header";
import { Footer } from "./index";

type Props = {
  children: React.ReactNode;
  headerData: any;
  footerData: any;
};
type ChromeData = { headerData: any; footerData: any };
const ChromeContext = createContext<ChromeData | null>(null);

export const useGlobalChrome = () => useContext(ChromeContext);

export function GlobalHeader() {
  const chrome = useGlobalChrome();
  const headerData = chrome?.headerData;
  if (!headerData) return null;
  return (
    <Header
      menuSuperieur={headerData.menuSuperieur}
      logo={headerData.menuPrincipal?.logo}
      menu={headerData.menuPrincipal?.menu}
    />
  );
}

export function GlobalFooter() {
  const chrome = useGlobalChrome();
  const footerData = chrome?.footerData;
  if (!footerData) return null;
  return (
    <Footer
      menuFooter={footerData.menuFooter}
      logoFooter={footerData.LogoFooter}
    />
  );
}

export default function GlobalHeaderFooter({
  children,
  headerData,
  footerData,
}: Props) {
  const pathname = usePathname();

  // Toutes les pages agences
  const isAgencyPage = pathname.startsWith("/portage-de-repas");

  return (
    <ChromeContext.Provider value={{ headerData, footerData }}>
      {!isAgencyPage && <GlobalHeader />}
      <main key={pathname} className="page-blur-out">{children}</main>
      {!isAgencyPage && <GlobalFooter />}
    </ChromeContext.Provider>
  );
}